import { BaseModel } from "../../../../../../../shared/src/lib/shared/models/entity/base/base.model";

interface IDatabaseFile {
    bucketName: string;
    
    name: string;
    
    size: number;
    
    contentType: string;
    
    fileType: string;
    
    url: string;
    
    extension: string;
    
    termsVersion: string;
    
    dataProtectionVersion: string;
    
    metadata: Record<string, any>;
    
    tags: string[];
    
    allowedUsages: string[];
    
    variations: Record<string, any>;
}

export class DatabaseFile extends BaseModel implements IDatabaseFile {
    bucketName: string;

    name: string;

    size: number;

    contentType: string;

    fileType: string;

    url: string;

    extension: string;

    termsVersion: string;

    dataProtectionVersion: string;

    metadata: Record<string, any>;

    tags: string[];

    allowedUsages: string[];

    variations: Record<string, any>;

    // --------------------------------------------------------------------------------------
    // @ CONSTRUCTOR
    // --------------------------------------------------------------------------------------

    constructor(init?: Partial<DatabaseFile>) {
        super(init);

        if (init) {
            Object.assign(this, init);
        }
    }
}

export class DatabaseFileImageMetadata {
    originalFileName: string;
}

export class DatabaseFileMetadata {
    originalFileName: string;
}

export abstract class BaseVariationData {
    size: number;
}

export class DatabaseFileImageVariation extends BaseVariationData {
    name: string;
    contentType: string;
    isDefault: boolean;
    url: string;
}

export class DatabaseFileVariation extends BaseVariationData {
    name: string;
    contentType: string;
    isDefault: boolean;
    url: string;
}